import { useState, useEffect } from 'react';
import { useSwipeable } from 'react-swipeable';
import { playUserAudio } from '../../../utils/dialogUtils';
//import { playUserAudioPromise } from '../../utils/playUserAudioPromise';
import { useAppConfig } from '../../../context/AppConfigContext';
import styles from './VocabularyBlock.module.css';
import { Capacitor } from '@capacitor/core';

const VocabularyBlock = ({ block, onComplete }) => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [currentExampleIndex, setCurrentExampleIndex] = useState(-1); // -1 = слово
  const [showTranslation, setShowTranslation] = useState(false);
  const [showWord, setShowWord] = useState(false);
  const [audioDuration, setAudioDuration] = useState(0);
  const [delayMs, setDelayMs] = useState(3000);
  const [isSliderCollapsed, setIsSliderCollapsed] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [currentTimer, setCurrentTimer] = useState(null);
  const { t, isNewUserInModule, isAndroidApp, site } = useAppConfig();
  const isNative = Capacitor.isNativePlatform();
  const combinedIsAndroidApp = isAndroidApp || isNative;  

  const currentWord = block.words[currentWordIndex];
  const isWordPhase = currentExampleIndex === -1;
  const currentItem = isWordPhase
    ? { phrase: currentWord.word, translation: currentWord.translation, audio: currentWord.audio }
    : currentWord.examples[currentExampleIndex];
	
  useEffect(() => {
    if (isPaused) return;
    
    setShowWord(false);
    setShowTranslation(true);
    setAudioDuration(0);

    const phraseTimer = setTimeout(() => {
      setShowWord(true);
    }, 1000);

    const audioSrc = `${combinedIsAndroidApp ? site : ''}${currentItem.audio}`;
    const audio = new Audio(audioSrc);

    audio.onloadedmetadata = () => {
      setAudioDuration(audio.duration * 1000);
    };
    playUserAudio(audioSrc);

    return () => {
      clearTimeout(phraseTimer);
      audio.onloadedmetadata = null;
    };
  }, [currentWordIndex, currentExampleIndex, currentItem.audio, isPaused]);

  useEffect(() => {
    if (audioDuration > 0 && !isPaused) {
      const hideTimer = setTimeout(() => {
        setShowWord(false);
        setShowTranslation(false);

        if (isWordPhase) {
          if (currentWord.examples.length > 0) {
            setCurrentExampleIndex(0);
          } else {
            moveToNextWord();
          }
        } else if (currentExampleIndex < currentWord.examples.length - 1) {
          setCurrentExampleIndex(currentExampleIndex + 1);
        } else {
          moveToNextWord();
        }
      }, audioDuration + delayMs);

      setCurrentTimer(hideTimer);
      return () => clearTimeout(hideTimer);
    }
  }, [audioDuration, currentExampleIndex, isWordPhase, currentWord.examples.length, isPaused, delayMs]);

  const moveToNextWord = () => {
    if (currentWordIndex < block.words.length - 1) {
      setCurrentWordIndex(currentWordIndex + 1);
      setCurrentExampleIndex(-1);
    } else {
      onComplete(5); // очки за завершение
    }
  };

  const moveToPreviousWord = () => {
    if (currentWordIndex > 0) {
      setCurrentWordIndex(currentWordIndex - 1);
      setCurrentExampleIndex(-1);
    }
  };

  const handlePause = () => {
    setIsPaused(!isPaused);
    if (currentTimer) {
      clearTimeout(currentTimer);
      setCurrentTimer(null);
    }
  };

  const handleNext = () => {
    if (currentTimer) {
      clearTimeout(currentTimer);
      setCurrentTimer(null);
    }
    moveToNextWord();
  };

  const handlePrevious = () => {
    if (currentTimer) {
      clearTimeout(currentTimer);
      setCurrentTimer(null);
    }
    moveToPreviousWord();
  };

  // свайп обработчики
  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => handleNext(),
    onSwipedRight: () => handlePrevious(),
    trackMouse: true // чтобы мышкой на десктопе тоже можно было
  });

  return (
    <>
      <div {...swipeHandlers} className={styles.content}>
        <img
          src={`${combinedIsAndroidApp ? site : ''}${currentWord.image}`}
          alt={currentWord.word}
          className={styles.image}
        />
        <div className={styles.textContainer}>
          {showTranslation && <p className={styles.translation}>{currentItem.translation}</p>}
          {showWord && <p className={styles.word}>{currentItem.phrase}</p>}
        </div>
      </div>
      
      {/* Control buttons */}
      <div className={styles.controlButtons}>
        <button onClick={handlePrevious} className={styles.controlButton}>
          ⏮
        </button>
        <button onClick={handlePause} className={styles.controlButton}>
          {isPaused ? '▶' : '⏸'}
        </button>
        <button onClick={handleNext} className={styles.controlButton}>
          ⏭
        </button>
      </div>

      {/* Slider container */}
      <div className={`${styles.sliderContainer} ${isSliderCollapsed ? styles.collapsed : ''}`}>
        <button 
          onClick={() => setIsSliderCollapsed(!isSliderCollapsed)} 
          className={styles.collapseButton}
        >
          {isSliderCollapsed ? '+' : '×'}
        </button>
        {!isSliderCollapsed && (
          <div className={styles.sliderContent}>
            <label htmlFor="delayRange" className={styles.sliderLabel}>
              {t.vocabularyBlock.delayBetweenPhrases.replace('{{seconds}}', Math.round(delayMs / 1000))}
            </label>
            <input
              id="delayRange"
              type="range"
              min="1000"
              max="6000"
              step="500"
              value={delayMs}
              onChange={(e) => setDelayMs(Number(e.target.value))}
              className={styles.slider}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default VocabularyBlock;





/*
import { useState, useEffect } from 'react';
import { useSwipeable } from 'react-swipeable';
import { playUserAudio } from '../../../utils/dialogUtils';
//import { playUserAudioPromise } from '../../utils/playUserAudioPromise';
import { useAppConfig } from '../../../context/AppConfigContext';
import styles from './VocabularyBlock.module.css';
import { Capacitor } from '@capacitor/core';

const VocabularyBlock = ({ block, onComplete }) => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [currentExampleIndex, setCurrentExampleIndex] = useState(-1); // -1 = слово
  const [showTranslation, setShowTranslation] = useState(false);
  const [showWord, setShowWord] = useState(false);
  const [audioDuration, setAudioDuration] = useState(0);
  const [delayMs, setDelayMs] = useState(3000);
  const { t, isNewUserInModule, isAndroidApp, site } = useAppConfig();
  const isNative = Capacitor.isNativePlatform();
  const combinedIsAndroidApp = isAndroidApp || isNative;  

  const currentWord = block.words[currentWordIndex];
  const isWordPhase = currentExampleIndex === -1;
  const currentItem = isWordPhase
    ? { phrase: currentWord.word, translation: currentWord.translation, audio: currentWord.audio }
    : currentWord.examples[currentExampleIndex];
	
  useEffect(() => {
    setShowWord(false);
    setShowTranslation(true);
    setAudioDuration(0);

    const phraseTimer = setTimeout(() => {
      setShowWord(true);
    }, 1000);

	const audioSrc = `${combinedIsAndroidApp ? site : ''}${currentItem.audio}`;
	const audio = new Audio(audioSrc);

	audio.onloadedmetadata = () => {
	  setAudioDuration(audio.duration * 1000);
	};
	playUserAudio(audioSrc);

    return () => {
      clearTimeout(phraseTimer);
      audio.onloadedmetadata = null;
    };
  }, [currentWordIndex, currentExampleIndex, currentItem.audio]);

  useEffect(() => {
    if (audioDuration > 0) {
      const hideTimer = setTimeout(() => {
        setShowWord(false);
        setShowTranslation(false);

        if (isWordPhase) {
          if (currentWord.examples.length > 0) {
            setCurrentExampleIndex(0);
          } else {
            moveToNextWord();
          }
        } else if (currentExampleIndex < currentWord.examples.length - 1) {
          setCurrentExampleIndex(currentExampleIndex + 1);
        } else {
          moveToNextWord();
        }
      }, audioDuration + delayMs);

      return () => clearTimeout(hideTimer);
    }
  }, [audioDuration, currentExampleIndex, isWordPhase, currentWord.examples.length]);

  const moveToNextWord = () => {
    if (currentWordIndex < block.words.length - 1) {
      setCurrentWordIndex(currentWordIndex + 1);
      setCurrentExampleIndex(-1);
    } else {
      onComplete(5); // очки за завершение
    }
  };

  const moveToPreviousWord = () => {
    if (currentWordIndex > 0) {
      setCurrentWordIndex(currentWordIndex - 1);
      setCurrentExampleIndex(-1);
    }
  };

  // свайп обработчики
  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => moveToNextWord(),
    onSwipedRight: () => moveToPreviousWord(),
    trackMouse: true // чтобы мышкой на десктопе тоже можно было
  });

  return (
    <>
      <div {...swipeHandlers} className={styles.content}>
		<img
		  src={`${combinedIsAndroidApp ? site : ''}${currentWord.image}`}
		  alt={currentWord.word}
		  className={styles.image}
		/>
        <div className={styles.textContainer}>
          {showTranslation && <p className={styles.translation}>{currentItem.translation}</p>}
          {showWord && <p className={styles.word}>{currentItem.phrase}</p>}
        </div>
      </div>
      <div className={styles.sliderContainer}>
        <label htmlFor="delayRange" className={styles.sliderLabel}>
          {t.vocabularyBlock.delayBetweenPhrases.replace('{{seconds}}', Math.round(delayMs / 1000))}
        </label>
        <input
          id="delayRange"
          type="range"
          min="1000"
          max="6000"
          step="500"
          value={delayMs}
          onChange={(e) => setDelayMs(Number(e.target.value))}
          className={styles.slider}
        />
      </div>
    </>
  );
};

export default VocabularyBlock;
*/